import React, { Fragment, useEffect, useState } from 'react';
import './../Resources/css/block_theSecret.css'

import Common from '../../../Shared/Common';
import Block from '../../../Controls/Scafolding/Block';

import { Row, Col } from 'reactstrap';
import { TextHeader, TextTitle, TextBock } from '../../../Controls/Digital/TextHeaders';

import imgProfile from '../Resources/Images/TheSecret/meetTheTeam.jpg';
import { AnimatedImage } from '../../../Controls/Digital/AnimatedImage';

const TheSecret = (props) =>{

    const [blockName, setBlockName] = useState("");

    useEffect(() => {
        setBlockName(props.name);
        Common.traceInit("Block " + blockName);
    });

    return (
        <Block name="theSecret" isAlt={true}>

            <Row>

                <Col lg="6" className="info">

                    <TextHeader text={
                        <Fragment>
                            A New Chapter
                        </Fragment>
                    } />

                    {/*<TextBock addClass="" text={*/}
                    {/*    <Fragment>*/}
                    {/*        Now run by a young family passionate about food and community, The Gwynneville Bakery enters a new chapter. Leo, trained as a chef in his hometown of Naples, brings a love for bold, simple ingredients. After moving to Australia in 2012, he worked in kitchens across Sydney and Wollongong before opening La Signora's Cafe in shellharbour, which served the community for over five years. Together with his family, Leo is proud to continue the legacy started by Jim and Maria, bringing new energy while honouring the bakery's beloved traditions.*/}
                    {/*    </Fragment>*/}
                    {/*} />*/}


                    <TextBock addClass="" text={
                        <Fragment>
                            Now run by a young family passionate about food and community, The Gwynneville Bakery enters a new chapter. 
                        </Fragment>
                    } />

                    <TextBock addClass="" text={
                        <Fragment>
                            Leo, trained as a chef in his hometown of Naples, brings a love for bold, simple ingredients.
                        </Fragment>
                    } />

                    <TextBock addClass="" text={
                        <Fragment>
                            After moving to Australia in 2012, he worked in kitchens across Sydney and Wollongong before opening La Signora's Cafe in shellharbour, which served the community for over five years.
                        </Fragment>
                    } />

                    <TextBock addClass="" text={
                        <Fragment>
                            Together with his family, Leo is proud to continue the legacy started by Jim and Maria, bringing new energy while honouring the bakery's beloved traditions.
                        </Fragment>
                    } />


                </Col>

                <Col lg="6" className="align-self-center">
                    <AnimatedImage image={imgProfile} animation="colorize" />
                </Col>

            </Row>


        </Block>
    );
}
export default TheSecret;
